import { DocumentNode, gql } from '@apollo/client';
import { LabelFragment } from './LabelFragmentGql';
import { TableCertificationFragmentGql } from './TableCertificationFragmentGql';
import { TableDatabaseNameFragmentGql } from './TableDatabaseNameFragmentGql';
import { TableauUserFragmentGql } from './TableauUserFragmentGql';


export const TablesDisplayGridRowDataFragmentGql: DocumentNode = gql`
fragment TablesDisplayGridRowData on Table {
  __typename
  id
  name
  description
  isEmbedded
  downstreamVirtualConnectionsConnection   {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  ... on DatabaseTable {
    luid
    contact {
      ...TableauUser
    }
    projectName
    projectVizportalUrlId
    ...TableCertification
    labels (filter: {isActive: true}) {
      ...Label
    }
  }
  ... on VirtualConnectionTable   {
    luid
    vizportalUrlId
    isCertified
    labels (filter: {isActive: true}) {
      ...Label
    }
    isExtracted
    extractLastRefreshedAt
  }
  ...TableDatabaseName
  columnsConnectionWithWarnings: columnsConnection(filter: {hasActiveWarning: true}) {
    totalCount
    nodes {
      labels (filter: {isActive: true}) {
        ...Label
        __typename
      }
    }
  }
  columnsConnection(first: 3, orderBy: { field: NAME, direction: ASC }) {
    totalCount
    nodes {
      name
    }
  }
}
${TableCertificationFragmentGql}
${TableDatabaseNameFragmentGql}
${TableauUserFragmentGql}
${LabelFragment}
`;
